import * as PIXI from "pixi.js";

import { IView } from "@src/core/game/components/IView";

export abstract class Popup implements IView {
  protected _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  protected abstract title: string;
  private get _title(): string {
    return this.title;
  }

  public get isVisible(): boolean {
    return this._view.visible;
  }

  protected content!: PIXI.Container;
  protected contentSizeX!: number;
  protected contentSizeY!: number;

  public abstract width: number;
  public abstract height: number;

  private _background!: PIXI.Graphics;
  private _titleText!: PIXI.Text;

  private PADDING: number = 20;
  private CORNER_RADIUS: number = 20;

  public constructor() {
    this.initializeComponents();
    this.initializeContent();
    this._parentComponents();

    this.setVisible(false);
  }

  public setVisible(visible: boolean): void {

    this._view.visible = visible;
  }

  protected initializeComponents(): void {
    this._background = new PIXI.Graphics();
    this._background.roundRect(
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height,
      this.CORNER_RADIUS,
    );
    this._background.fill(0x000000); // Dark gray
    this._background.alpha = 0.85;
    this._background.interactive = true;

    this._titleText = new PIXI.Text({
      text: this._title,
      style: {
        fill: "0xff8531",
        fontWeight: "bold",
        fontSize: 30,
        fontFamily: "uiFont",
      },
    });
    this._titleText.anchor.set(0.5);
    this._titleText.position.set(
      0,
      this.height / -2 + this._titleText.style.fontSize + this.PADDING,
    );

    const titleHeight: number =
      this._titleText.style.fontSize + this.PADDING * 2;

    const contentPosX: number = 0;
    const contentPosY: number = titleHeight / 2;
    const contentSizeX: number = this.width - this.PADDING * 2;
    const contentSizeY: number = this.height - titleHeight - this.PADDING * 2;

    this.content = new PIXI.Container();
    this.content.position.set(contentPosX, contentPosY);
    this.contentSizeX = contentSizeX;
    this.contentSizeY = contentSizeY;

    // Used to serve for debugging the content bounds
    // const graphics = new PIXI.Graphics();
    // graphics.roundRect(
    //   -contentSizeX / 2,
    //   -contentSizeY / 2,
    //   contentSizeX,
    //   contentSizeY,
    //   this.CORNER_RADIUS,
    // );
    // graphics.fill(0xffffff);
    // this.content.addChild(graphics);
  }

  protected initializeContent(): void { }

  private _parentComponents(): void {
    this._view.addChild(this._background);
    this._view.addChild(this._titleText);
    this._view.addChild(this.content);
  }
}
